export default __webpack_public_path__ + "static/media/Caramel-Epoque-2.c72fc90a.jpg";